import React, { useState } from 'react';

import { SOSemergencyEnableButton } from '../../components/common/SOSemergencyEnableButton';
import SearchBox from '../../components/common/searchBox';

import * as routeNames from '../../routes/routeName';
import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';
import * as Hooks from '../../hooks';
import { useAuthSelector } from '../../services/selectors/authSelector';
import Updates3x4x from './3x4x';
import EmergenciesTab from './emergenciesTab';

const Updates = () => {
    const navigate = Hooks.useCustomNavigate();
    const { pharmacyId } = useAuthSelector();

    const [activeTab, setActiveTab] = useState('3x4x');

    return (
        <>
            <div className="app-wrapper flex justify-center">
                <div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden">
                    <div className="relative p-4">
                        <Common.TopBar pharmacyId={pharmacyId} />

                        <div className="my-4">
                            <SearchBox />
                        </div>

                        <div className="mt-4">
                            <div className="inline-flex bg-gray-100 rounded-md p-1">
                                <button
                                    className={`px-4 py-1 rounded-md transition-colors ${activeTab === '3x4x' ? 'bg-white shadow text-gray-900 font-semibold' : 'text-gray-600'}`}
                                    onClick={() => setActiveTab('3x4x')}
                                >
                                    3x 4x
                                </button>
                                <button
                                    className={`ml-2 px-4 py-1 rounded-md transition-colors ${activeTab === 'emergencies' ? 'bg-white shadow text-gray-900 font-semibold' : 'text-gray-600'}`}
                                    onClick={() => setActiveTab('emergencies')}
                                >
                                  No Emergencies
                                </button>
                            </div>

                            <div className="mt-4">
                                {activeTab === '3x4x' && (
                                    <Updates3x4x />
                                )}

                                {activeTab === 'emergencies' && (
                                    <EmergenciesTab />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Updates;
